var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.196 49.2435L66.8114 15.2172C65.5801 11.8343 61.9042 10.3309 58.6521 11.8338L58.483 11.8954C52.7476 14.5575 44.8527 20.8471 40.9839 25.8308L40.6175 26.3153C39.9847 27.1203 38.6315 27.6128 37.6293 27.403L36.7706 27.2366C30.6137 25.9338 20.5614 26.2085 14.4669 27.884C11.0096 28.8231 9.19857 32.3555 10.4196 35.7102L22.8144 69.7647C23.7994 72.471 26.9217 74.2078 29.7512 73.5611L30.6098 73.3763C37.0247 71.9673 47.5973 71.631 54.0873 72.621L54.2206 72.6363C55.1356 72.7821 56.3478 72.3409 56.9269 71.6513C61.2519 66.693 69.5851 60.1163 75.4331 57.062L76.3224 56.6106C78.9055 55.2873 80.181 51.9498 79.196 49.2435Z",
    stroke: "#023527",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.462 27.7896L54.8529 70.0757",
    stroke: "#023527",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5591 40.6074L24.2162 42.916",
    stroke: "#023527",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7516 48.2951L27.2944 51.3733",
    stroke: "#023527",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.77f2610329cb849ae79ecb6497ae1703.svg";
export { ForwardRef as ReactComponent };